import { DisqualifyAllProductsDialogProps } from "@models/platform-analysis/entities/analysis";

export const getDialogHeader = (
  disqualifyProps?: DisqualifyAllProductsDialogProps,
) => {
  const { numOfUndecidedProducts = 0 } = disqualifyProps || {};

  return `Disqualify ${
    numOfUndecidedProducts > 1 ? "all " : ""
  }undecided ${pluralize(numOfUndecidedProducts, "platform")}?`;
};

export const getDialogBody = (
  disqualifyProps?: DisqualifyAllProductsDialogProps,
) => {
  const {
    numOfShortlistedProducts = 0,
    numOfDisqualifiedProducts = 0,
    numOfUndecidedProducts = 0,
  } = disqualifyProps || {};

  return `You have shortlisted ${numOfShortlistedProducts} ${pluralize(
    numOfShortlistedProducts,
    "platform",
  )} and disqualified ${numOfDisqualifiedProducts} ${pluralize(
    numOfDisqualifiedProducts,
    "platform",
  )}.
    There ${
      numOfUndecidedProducts === 1 ? "is" : "are"
    } still ${numOfUndecidedProducts} ${pluralize(
    numOfUndecidedProducts,
    "platform",
  )} you have not made a decision on.
    Automatically disqualify ${
      numOfUndecidedProducts > 1 ? "these " : ""
    }undecided ${pluralize(numOfUndecidedProducts, "platform")}?`;
};

const pluralize = (count: number, singular: string, plural?: string) =>
  count === 1 ? singular : plural || `${singular}s`;
